import React from 'react';

const Button = ({ handleClick, children, buttonStyles, buttonID, ...rest }) => (
		// eslint-disable-next-line react/jsx-props-no-spreading,react/button-has-type
        <button {...rest}  onClick={handleClick} className={buttonStyles} id={buttonID}>
            {children}
        </button>
    );

export default Button;
